"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.atatFetch = exports.toFetchOptions = void 0;
/* eslint-disable camelcase */
/* eslint @typescript-eslint/no-explicit-any: 1 */
const fluture_1 = require("fluture");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const isomorphic_form_data_1 = __importDefault(require("isomorphic-form-data"));
const path_1 = __importDefault(require("ramda/src/path"));
const constants_1 = require("../constants");
const atat_1 = require("../secrets/atat");
const errorLogging_1 = require("../thirdparty/errorLogging");
const fluture_utils_1 = require("../utils/fluture-utils");
const toFetchOptions = (request) => {
    const body = Object
        .keys(request.body)
        .reduce((formData, k) => {
        formData.append(k, request.body[k]);
        return formData;
    }, new isomorphic_form_data_1.default());
    const opts = {
        // TODO fix this ignore
        // @ts-ignore
        body: body,
        method: request.method
    };
    // append optional args
    const optsWithOrigin = request.origin ? {
        ...opts,
        ...{ headers: { origin: request.origin } }
    } : opts;
    return request.token ? {
        ...optsWithOrigin,
        ...{ headers: { authorization: `Bearer ${request.token}` } }
    } : optsWithOrigin;
};
exports.toFetchOptions = toFetchOptions;
/**
 * Wraps a request to atat into a fetch request and returns a forked future.
 */
const atatFetch = (request) => 
// TODO fix these any types
(handleFailure) => (handleSuccess) => {
    const requestQueryString = (0, path_1.default)(['body', 'query'], request);
    const platformParam = 'platform=fcp';
    const atatFetchWithRetry = (retryCount) => (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(`${atat_1.atatUrl}`, 
    // TODO fix this ignore
    // @ts-ignore
    (0, exports.toFetchOptions)({
        ...request,
        body: {
            ...request.body,
            query: requestQueryString ? `${requestQueryString}&${platformParam}` : `?${platformParam}`
        }
    })))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody))
        .pipe((0, fluture_1.fork)((e) => {
        (0, errorLogging_1.logError)(e);
        retryCount > 0 ? atatFetchWithRetry(retryCount - 1) : handleFailure && handleFailure(e);
    })(handleSuccess));
    atatFetchWithRetry(constants_1.MAX_ATAT_RETRY_COUNT);
};
exports.atatFetch = atatFetch;
//# sourceMappingURL=atatClient.js.map